import { Injector, Injectable, afterNextRender, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ROUTES } from '../../shared/constants/routes.constants';

/**
 * Angular Router non sposta il focus dopo la navigazione: senza questo servizio,
 * chi naviga da tastiera/screen reader resta con il focus sull'elemento della vista
 * precedente e non riceve alcun annuncio di cambio pagina.
 * Ogni componente di route deve avere un `<h1 tabindex="-1">` (anche solo sr-only)
 * come punto di ingresso accessibile.
 * Eccezione: sulla Home il focus non viene spostato, così l'utente può esplorare
 * l'header partendo dall'alto.
 */
@Injectable({ providedIn: 'root' })
export class RouteFocusService {
  private router = inject(Router);
  private injector = inject(Injector);

  constructor() {
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e) => {
        if (this.isHome(e.urlAfterRedirects)) return;
        // Dopo il render: nel microtask l'h1 della pagina precedente è ancora nel DOM
        // e il focus andrebbe perso quando la vecchia vista viene distrutta.
        afterNextRender(() => {
          const heading = document.querySelector<HTMLElement>('h1[tabindex="-1"]');
          heading?.focus();
        }, { injector: this.injector });
      });
  }

  private isHome(url: string): boolean {
    const path = url.split(/[?#]/)[0].replace(/^\/+|\/+$/g, '');
    return path === '' || path === ROUTES.HOME;
  }
}
